import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { COOKIE_NAME } from './authCookies';
import { useNavigation } from './navigation';
import { REG_MODAL_FLOW } from '@/components/_promo/helpers/common';
import { getCookie } from '@/helpers/common';

const TIME_TO_REDIRECT = 10e3; // 10 seconds

export const usePromoRedirect = (name: string) => {
  const { navigate } = useNavigation();
  const searchParams = useSearchParams();

  const isRegModalFlow = Boolean(searchParams.get(REG_MODAL_FLOW));

  useEffect(() => {
    const promoStayTime = localStorage.getItem(`promo-visit-time-${name}`);
    const currentTime = Date.now();

    if (getCookie(COOKIE_NAME.ACTIVE_SESSION) === 'true') {
      navigate('/');
      return;
    }

    if (getCookie(COOKIE_NAME.IS_REGISTERED) === 'true') {
      navigate('/?modal=login');
      return;
    }

    if (!promoStayTime) {
      localStorage.setItem(`promo-visit-time-${name}`, `${currentTime}`);
      return;
    }

    const elapsedTimeMilliseconds = currentTime - +promoStayTime;

    if (!(elapsedTimeMilliseconds >= TIME_TO_REDIRECT) || isRegModalFlow)
      return;

    navigate('/?modal=registration');
  }, [name, navigate, searchParams]);
};
